<template>
	<div>
		<!-- <el-row>
			<el-col :span="24">
				<div class="none2">
					<span>暂无数据 ！</span>
				</div>
			</el-col>
		</el-row> -->
		<div>
			<el-dialog title="添加点位" :visible.sync="addVisible" width="40%" :before-close="formClose" center>
				<div v-loading="$store.state.formload">
					<el-form :model="adrForm" :rules="rules" ref="adrForm" label-width="25%">
						<el-form-item label="类型" prop="class" style="width:100%;" @change="select()">
							<el-radio-group v-model="adrForm.class">
								<el-radio :label="1">终端</el-radio>
								<el-radio :label="2">摄像头</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="编号" prop="num" style="width:100%;">
							<el-input v-model.number="adrForm.num" placeholder="请输入编号"></el-input>
						</el-form-item>
						<el-form-item label="名称" prop="content" style="width:100%;">
							<el-input v-model="adrForm.content" placeholder="请输入名称"></el-input>
						</el-form-item>
						<el-form-item v-show="adrForm.class==1" label="终端列表" :prop="adrForm.class==1?'zd':'sx'" style="width:100%;">
							<el-select v-model="adrForm.zd" multiple placeholder="请选择" style="width:100%;">
								<el-option
								  v-for="item in $store.state.Iot.terminal"
								  :key="item.id"
								  :label="item.name"
								  :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item v-show="adrForm.class==2" label="摄像头列表" :prop="adrForm.class==2?'sx':'zd'" style="width:100%;">
							 <el-cascader
							  v-model="adrForm.sx"
							  placeholder="输入可搜索"
							  :options="$store.getters.dwvideo"
							  style="width:100%;"
							  :props="props"
							  filterable
							  collapse-tags>
								<template slot-scope="{ node, data }">
									<span>{{ data.name }}</span>
									<span v-if="!node.isLeaf"> ({{ data.videoList.length }}) </span>
								</template>
							</el-cascader>
						</el-form-item>
					</el-form>
					<div slot="footer" class="dialog-footer">
						<el-button type="primary" @click="addAdr()">保 存</el-button>
						<el-button @click="addVisible = false">取 消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
		<el-row>
			<el-col :span="24">
				<div class="bread">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item :to="{ path: '/location' }">基地全景</el-breadcrumb-item>
						<el-breadcrumb-item>基地分布</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</el-col>
		</el-row>
		<el-row class="top">
			<el-col :span="24">
				<el-upload
				  :action="config['apiurl'] + '/api/common/upload'"
				  :show-file-list="false"
				  ref="upload"
				  :on-success="handleAvatarSuccess"
				  :before-upload="beforeAvatarUpload"
				  :auto-upload="false"
				  :on-change="update">
					<el-button type="primary" icon="el-icon-circle-plus-outline" @click="up=true">添加基地图片</el-button>
				</el-upload>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<div class="zdimgdiv">
					<div style="z-index: 100;" v-for="item in $store.state.main.distribute.list" :key="item.num" class="zddw" :style="'top:'+item.height+'px;left:'+item.width+'px;'">
						<el-tooltip placement="top" effect="light">
							<div class="zddhk" slot="content">
								<el-row>
									<el-col :span="24" class="dw-title">{{item.name}}</el-col>
									<div v-show="item.type==1">
										<el-col :span="24" v-show="item.m_terminal_all_json.length>0">
											<el-col :span="24">
												<span class="sonser">终端数({{item.m_terminal_all_json.length}}个)</span>
											</el-col>
											<el-col :span="24" class="data">
												<el-button type="text" @click="skipZ(i)" class="mybutton" v-for="i in item.m_terminal_all_json" :key="i.id">{{i.name}}</el-button>
											</el-col>
										</el-col>
										<el-col :span="24" class="xx-top" v-show="item.devices_count>0">
											<el-col :span="24">
												<span class="sonser">传感器数({{item.devices_count}}个)</span>
											</el-col>
											<el-col :span="24" class="data">
												<span>{{item.devices_name}}</span>
											</el-col>
										</el-col>
									</div>
									<div v-show="item.type==2">
										<el-col :span="24" v-show="item.m_video_bc_json.length>0">
											<el-col :span="24">
												<span class="sonser">球机数({{item.m_video_bc_json.length}}个)</span>
											</el-col>
											<el-col :span="24" class="data">
												<el-button type="text" @click="skipK(i)" class="mybutton" v-for="i in item.m_video_bc_json" :key="i.id">{{i.name}}</el-button>
											</el-col>
										</el-col>
										<el-col :span="24" class="xx-top" v-show="item.m_video_g_json.length>0">
											<el-col :span="24">
												<span class="sonser">枪机数({{item.m_video_g_json.length}}个)</span>
											</el-col>
											<el-col :span="24" class="data">
												<el-button type="text" @click="skipK(i)" class="mybutton" v-for="i in item.m_video_g_json" :key="i.id">{{i.name}}</el-button>
											</el-col>
										</el-col>
									</div>
									<el-col :span="24" class="del">
										<el-button size="small" type="warning" @click="delAdr(item)">删除</el-button>
									</el-col>
								</el-row>
							</div>
							<el-button class="zdbutton">{{item.no}}</el-button>
						</el-tooltip>
					</div>
					<el-image class="zdimg" :style="'height: '+height+'px;'" :src="config.apiurl + $store.state.main.distribute.distribute_image" @click="openaddAdr($event)">
						<div slot="error" class="image-slot">
							请添加基地图片!
						</div>
					</el-image>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				up: false,
				width: 0,
				height: 0,
				clicktime: 0,
				props: {
					multiple: true,
					value: 'id',
					label: 'name',
					children: 'videoList'
				},
				addVisible: false,
				adrForm: {
					num: 0,
					class: 1,
					width: 0,
					height: 0,
					content: '',
					zd: [],
					sx: []
				},
				rules: {
					num: [
						{ required: true, message: '请输入编号', trigger: 'blur' },
						{ type: 'number', message: '编号必须为数字值'},
						{ pattern:/^\d{1,2}$/, message: '最多两位数', trigger: 'blur' }
					],
					class: [
						{ required: true, message: '请选择类型', trigger: 'blur' }
					],
					content: [
						{ required: true, message: '请输入名称', trigger: 'blur' }
					],
					zd: [
						{ required: true, message: '请选择终端', trigger: 'blur' }
					],
					sx: [
						{ required: true, message: '请选择摄像头', trigger: 'blur' }
					]
				},
				imgup: true
			}
	 	},
	 	mounted: function () {
			this.$notify.info({ title: '提示', message: '添加基地图片后，双击图片可在双击处添加终端！' });
			this.load();
	 	},
		methods: {
			getHeight() {
				this.width = window.innerWidth - 290;
				this.height = this.width / 2.2;
				this.$store.commit('setdw');
			},
			handleAvatarSuccess(res, file) {
				this.image = res.data.url;
				this.editimg();
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg'||file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;
			
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			update()
			{
				if(this.up)
				{
					if(!(this.$store.state.main.distribute.distribute_image==null||this.$store.state.main.distribute.distribute_image==''||this.$store.state.main.distribute.distribute_image=="0"))
					{
						this.$confirm('此操作将覆盖原基地图片，是否继续？', '警告', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						})
						.then(() => {
							this.$refs.upload.submit();
						})
						.catch(() => {
							this.$refs.upload.clearFiles();
						});
					}
					else
					{
						this.$refs.upload.submit();
					}
					this.up=false;
				}
			},
			openaddAdr($event)
			{
				if(this.$store.state.main.distribute.distribute_image==''||this.$store.state.main.distribute.distribute_image==null||this.$store.state.main.distribute.distribute_image=="0")
				{
					 this.$message({ message: '请添加基地图片！', type: 'warning' });
					return;
				}
				let nowtime=new Date().getTime();
				if(nowtime-this.clicktime>=500)
				{
					this.clicktime=nowtime;
					return;
				}
				this.getZD();
				this.getSX();
				this.addVisible=true;
				this.$nextTick(()=>{
					this.$refs['adrForm'].resetFields();
					this.adrForm.width=($event.layerX-35)/this.width;
					this.adrForm.height=($event.layerY-10)/this.height;
					this.adrForm.num=this.$store.state.main.distribute.list.length+1;
				});
			},
			addAdr()
			{
				this.$refs['adrForm'].validate((valid) => {
					if(valid)
					{
						this.$store.commit('formload',true);
						let terminal,video;
						if(this.adrForm.zd.length>0)
						{
							terminal=this.adrForm.zd[0].toString();
						}
						for(let i=1;i<this.adrForm.zd.length;i++)
						{
							terminal=terminal+","+this.adrForm.zd[i];
						}
						if(this.adrForm.sx.length>0)
						{
							video=this.adrForm.sx[0][1].toString();
						}
						for(let i=1;i<this.adrForm.sx.length;i++)
						{
							video=video+","+this.adrForm.sx[i][1];
						}
						let value={
							qaedas_id: this.$route.query.id,
							type: this.adrForm.class,
							no: this.adrForm.num,
							axis_x: this.adrForm.width.toFixed(4),
							axis_y: this.adrForm.height.toFixed(4),
							name: this.adrForm.content,
							terminal_all_id: this.adrForm.class==1?terminal:"",
							video_all_id: this.adrForm.class==2?video:""
						};
						this.adddistribute(value)
						.then((response) => {
							if(response.data.code==1)
							{
								this.addVisible=false;
							}
							this.$store.commit('formload',false);
						});
					}
				});
			},
			getZD()
			{
				let  value={
					qaedas_id: this.$route.query.id,
					type: 1
				};
				this.getterminal(value);
			},
			getSX()
			{
				let value={
					qaedas_id: this.$route.query.id,
					type: 1
				};
				this.getvcr(value);
			},
			editimg()
			{
				let value={
					id: this.$route.query.id,
					distribute_image: this.image
				};
				this.editqaedas(value)
				.then((response)=>{
					if(response.data.code==1)
					{
						this.$forceUpdate();
					}
				});
			},
			delAdr(item)
			{
				this.$confirm('是否删除此点位？', '提示', {
					confirmButtonText: '删除',
					cancelButtonText: '取消',
					type: 'warning'
				})
				.then(() => {
					let value={
						id: item.id,
						qaedas_id: this.$route.query.id
					};
					this.deldistribute(value);
				})
			},
			skipZ(item)
			{
				this.setCookie(this.config.jdid,this.$route.query.id,3);
				this.$router.push({path:'/iot/sensor',query:{ id: item.id}});
			},
			skipK(item)
			{
				this.setCookie(this.config.jdid,this.$route.query.id,3);
				this.$router.push({path:'/video/singlectr',query:{ id: item.id}});
			},
			load()
			{
				if(this.$store.state.width<this.$store.state.minwidth)
				{
					this.$message({
						message: "分辨率过低无法访问基地分布！",
						type: 'error',
						center: true,
					});
					this.$router.push("/location");
					return;
				};
				this.$store.commit('mainload',true);
				let value={
					qaedas_id: this.$route.query.id
				};
				this.getdistribute(value)
				.then((response) => {
					if(response.data.code==1)
					{
						this.$store.commit('mainload',false);
					}
				});
			}
		},
		created() {
			window.addEventListener('resize', this.getHeight);
			this.getHeight()
		},
		destroyed() {
			window.removeEventListener('resize', this.getHeight)
		}
	}
</script>

<style scoped>
	.none2{
		margin-top: 80px;
		margin-bottom: 80px;
		text-align: center;
		font-size: 80px;
		font-family: "STCaiyun";
		color: #1991FA;
	}
	.zdimgdiv{
		margin-top: 10px;
	}
	.zdimg{
		width: 100%;
	}
	.zddw{
		position: absolute;
		width: 46.5px;
	}
	.zdbutton{
		border: 0px !important;
		background-image: url(../../assets/main/dw.png) !important;
		background-color: rgb(0,0,0,0) !important;
		background-color: rgba(0,0,0,0) !important;
		width: 46.5px !important;
		height: 50px !important;
		padding: 0px !important;
		padding-bottom: 15px !important;
		text-align: center !important;
	}
	.zdbutton:hover{
		background-color: rgb(0,0,0,0) !important;
	}
	.zddhk{
		width: 350px;
		font-size: 20px;
	}
	.title{
		text-align: center;
		margin-top: -10px;
	}
	.top{
		margin-top: 0px;
	}
	.dialog-footer{
		text-align: center;
	}
	.del{
		text-align: right;
		margin-top: 10px;
	}
	.sonser{
		font-size: 16px;
		color: #7c7f86;
	}
	.data{
		border: 1px solid #dcdfe6;
		border-radius:4px;
		font-size: 17px;
	}
	.mybutton{
		margin-left: 5px !important;
		margin-right: 5px !important;
	}
	.dw-title{
		text-align: center;
	}
	.xx-top{
		margin-top: 5px;
	}
	.bread{
		height: 14px;
		padding: 8px 0;
	}
	.image-slot {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
		background: #FFFFFF;
		color: red;
	}
</style>